<template>
  <button v-if="this.cookieConsentStrings[this.currLocale]?.show_consent_banner" @click="openconsent">{{ manage_cookies }}</button>
</template>

<script>
import { mapState } from 'vuex';
export default {
  methods: {
    openconsent() {
      this.$CookieConsent.showPreferences();
    }
  },
  computed: {
    ...mapState(['cookieConsentStrings']),
    manage_cookies() {
      return this.cookieConsentStrings[this.currLocale]?.manage_cookies_label || "";
    }
  }
};
</script>

<style scoped lang="scss">
button {
  font-family: inherit;
  font-weight: 500;
  background-color: transparent;
  font-size: inherit;
  padding: 0;
  color: white;
  border: none;
  cursor: pointer;
  z-index: 10000;
  transition: background-color 400ms;
}
</style>
